import React from 'react';
import moment from 'moment';

const formatDate = (date) => moment(date).utcOffset(new Date().getTimezoneOffset() * -1).format('Do MMMM YYYY, H:mm:ss');
const shortFormatDate = (date) => moment(date).utcOffset(new Date().getTimezoneOffset() * -1).format('DD/MM/YY, H:mm:ss');

const formatNotificationFailureReason = (failureReason) => {
  switch (failureReason) {
    case 'INVALID_FCM_TOKEN': return 'Disconnect / reconnect on the app';
    case 'OS_SETTINGS_PUSH_DISABLED': return 'Enable push notifications on OS settings';
    case 'APP_SETTINGS_PUSH_DISABLED': return 'Enable notifications in Lovebox app';
    case 'LOCAL_PUSH_FAILED': return 'Either user clicked on "No" but saw the notification, or phone can\'t display notifications. Tell user to do the test again.';
    case 'REMOTE_PUSH_FAILED': return 'Server fails delivering message to user. Contact @devs.';
    default: return 'Unknown issue. Contact @devs.';
  }
};

const formatVersion = ({ version, lastVersion, betaVersion }) => {
  let text;
  let color = 'black';
  if (!version) return undefined;

  if (!lastVersion) text = `${version}`;
  else if (version === lastVersion) text = `${version} - last stable version 🎉`;
  else if (version === betaVersion) text = `${version} - beta version 🛠`;
  else {
    color = 'red';
    text = `${version} - not up-to-date, last version: ${lastVersion}`;
  }

  return (
    <li style={{ color }}>
      {`App version: ${text}`}
    </li>
  );
};

const getBoxType = ({ hardware, hasColor }) => {
  switch (hardware) {
    case '3': return 'Very old Lovebox V1 (3)';
    case '5': return 'Old Lovebox V1 (5)';
    case '6': return 'Lovebox V1 (6)';
    case 'C1': return `Lovebox bêta ${hasColor ? 'Color' : 'B&W'} (C1)`;
    case 'C2': return `Lovebox ${hasColor ? 'Color' : 'B&W'} (C2)`;
    default: return `Unknown box type ${hardware}`;
  }
};

const getLanguage = (language) => ((language === 'fr') ? 'French' : 'English');

export {
  formatDate,
  shortFormatDate,
  formatNotificationFailureReason,
  formatVersion,
  getBoxType,
  getLanguage,
};



// WEBPACK FOOTER //
// ./src/services/format-utils.js